import React from "react";
import { isNegative, formatNumber } from "../../balanceSheetUtils";
import { tableStyles } from "../../balanceSheetStyles";

const getRowFontWeight = (type, level) => {
  if (type === "grouptotal" || type === "subtotal") return "600";
  if (level === 0) return "600";
  if (level === 1) return "500";
  return "normal";
};

export const BalanceSheetRow = ({ row, onToggle, isRTL }) => {
  const hasChildren = row.children?.length > 0;
  const paddingLeft = tableStyles.getPaddingLeft(row.level || 0);
  const values = Array.isArray(row.values) ? row.values : [];
  const rowStyle = tableStyles.getRowStyles(row.type);
  const rowInlineStyle = {
    background: rowStyle.bg,
    color: rowStyle.color,
    fontSize: rowStyle.fontSize,
    borderTop: rowStyle.borderTop,
  };

  return (
    <>
      <tr
        style={{
          ...rowInlineStyle,
          cursor: hasChildren ? "pointer" : "default",
        }}
        onClick={hasChildren ? () => onToggle(row.id) : undefined}
      >
        <td
          style={{
            position: "sticky",
            left: 0,
            zIndex: 5,
            background: rowStyle.bg === "transparent" ? "#ffffff" : rowStyle.bg,
            borderInlineEnd: "1px solid #eaeef2",
            minWidth: "300px",
            maxWidth: "300px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: isRTL ? "right" : "left",
            fontWeight: getRowFontWeight(row.type, row.level),
            paddingInlineStart: isRTL ? undefined : paddingLeft,
            paddingInlineEnd: isRTL ? paddingLeft : undefined,
            paddingBlock: "8px",
          }}
        >
          <span style={{ color: "#F9A825", fontSize: "11px", marginInlineEnd: "8px" }}>
            {hasChildren ? (row.isOpen ? "▼" : "▶") : " "}
          </span>
          {row.label}
        </td>
        {values.map((value, index) => (
          <td
            key={`${row.id}-${index}`}
            style={{
              textAlign: isRTL ? "left" : "right",
              whiteSpace: "nowrap",
              color: index > 0 && isNegative(value) ? "#dc3545" : "#333333",
              fontWeight: getRowFontWeight(row.type, row.level),
              padding: "8px 6px",
            }}
          >
            {index === 0 ? value : formatNumber(value)}
          </td>
        ))}
      </tr>

      {row.isOpen && row.children?.length
        ? row.children.map((child) => (
            <BalanceSheetRow key={child.id} row={child} onToggle={onToggle} isRTL={isRTL} />
          ))
        : null}
    </>
  );
};
